// Side-effect import: bootstrap's js registers its data-api handlers on the document,
// which is all this site needs it for - the navbar toggler is the only component in use.
import 'bootstrap';

// Click-to-zoom: any img.img-zoomable opens full-screen in an overlay.
// Click anywhere or Esc closes it.
// Version history: every pre[data-changelog] loads the versions JSON named in the
// attribute and renders its changelog, newest first.
document.querySelectorAll<HTMLElement>('pre[data-changelog]').forEach((pre) => {
    fetch(pre.dataset.changelog ?? '')
        .then((r) => r.json())
        .then((data: { changelog?: Record<string, string> }) => {
            const log = data.changelog;
            if (!log) {
                pre.textContent = 'No version history yet.';
                return;
            }
            const versions = Object.keys(log).sort((a, b) => {
                const pa = a.split('.').map(Number);
                const pb = b.split('.').map(Number);
                for (let i = 0; i < 3; i++) {
                    if ((pa[i] || 0) !== (pb[i] || 0)) {
                        return (pb[i] || 0) - (pa[i] || 0);
                    }
                }
                return 0;
            });
            pre.textContent = versions.map((v) => v + '\n  ' + log[v]).join('\n\n');
        })
        .catch(() => {
            pre.textContent = 'Could not load version history.';
        });
});

// Copy buttons: every pre.copyable gets a corner button that copies its text.
const sprite = document.body.dataset.icons ?? '';

document.querySelectorAll('pre.copyable').forEach((pre) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'copy-button';
    button.title = 'Copy to clipboard';

    const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('class', 'icon');
    icon.setAttribute('aria-hidden', 'true');
    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttribute('href', `${sprite}#copy`);
    icon.appendChild(use);
    button.appendChild(icon);

    button.addEventListener('click', () => {
        const text = pre.querySelector('code')?.textContent ?? pre.textContent ?? '';
        navigator.clipboard.writeText(text.trim()).then(() => {
            use.setAttribute('href', `${sprite}#check`);
            setTimeout(() => {
                use.setAttribute('href', `${sprite}#copy`);
            }, 1500);
        });
    });
    pre.appendChild(button);
});

document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof HTMLImageElement) || !target.classList.contains('img-zoomable')) {
        return;
    }

    const overlay = document.createElement('div');
    overlay.className = 'img-zoom-overlay';

    const image = document.createElement('img');
    image.src = target.src;
    image.alt = target.alt;
    overlay.appendChild(image);

    const close = () => {
        overlay.remove();
        document.removeEventListener('keydown', onKeydown);
    };
    const onKeydown = (keyEvent: KeyboardEvent) => {
        if (keyEvent.key === 'Escape') {
            close();
        }
    };

    overlay.addEventListener('click', close);
    document.addEventListener('keydown', onKeydown);
    document.body.appendChild(overlay);
});
